import {mobileConstants, uriConstants} from '../../constants'
import {defaultService} from '../../services'
import { errorMessages } from '../../messages'
import {alertActions} from '../'


export const mobileActions = {
  load,
  select,
  del,
  delAll,
  count
}

/*******************
  method 반드시 이렇게..

  GET    = Read
  POST   = Create
  PUT    = Update
  DELETE = Delete
********************/

/*********
 알람 건수조회
**********/

function count(params) {
  return async dispatch => {
    dispatch(apiAction(mobileConstants.COUNT_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.MOBILE_ALARM_COUNT + paramStr,
    })
      .then(
          response => {
            dispatch(apiAction(mobileConstants.COUNT_SUCCESS, response))
          },
          error => {
            dispatch(apiAction(mobileConstants.COUNT_FAILURE, error))
          }
      )
  }
}

/*********
 목록조회
 **********/

function load(params) {
  return async dispatch => {
    dispatch(apiAction(mobileConstants.LOAD_REQUEST))

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.MOBILE_ALARM_LIST + paramStr,
    })
        .then(
            response => {
              dispatch(apiAction(mobileConstants.LOAD_SUCCESS, response))
            },
            error => {
              dispatch(apiAction(mobileConstants.LOAD_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
}


/******
 선택삭제
 *****/

function del(alarmSeq) {
  return async  dispatch => {
    dispatch(apiAction(mobileConstants.DELETE_REQUEST))

    defaultService.handleService({
      method: 'delete',
      endPoint: uriConstants.API_URI + uriConstants.MOBILE_ALARM_LIST + '/' + alarmSeq,
    })
        .then(
            response => {
              dispatch(apiAction(mobileConstants.DELETE_SUCCESS, response))
            },
            error => {
              dispatch(apiAction(mobileConstants.DELETE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
}


/*******
 전체삭제
 *******/

function delAll() {
  return async  dispatch => {
    dispatch(apiAction(mobileConstants.DELETE_REQUEST))

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.MOBILE_ALARM_DELETE_ALL,
    })
        .then(
            response => {
              dispatch(apiAction(mobileConstants.DELETE_SUCCESS, response))
            },
            error => {
              dispatch(apiAction(mobileConstants.DELETE_FAILURE, error))
              dispatch(apiError(error))
            }
        )
  }
}


/*********
 셀렉트
**********/

function select(params) {
  return async dispatch => {
    dispatch(request())
  }
  function request() {
    return {
      type: mobileConstants.SELECT_REQUEST,
      params
    }
  }
}


/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = {type};
  response && (resultObj.response = response)
  return resultObj;
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}
